// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-container[data-v-36079405]{width:calc(100% - 91px);height:calc(100% - 99px);background-color:#f4f8f9;margin-right:0;margin-left:auto}", ""]);
// Exports
module.exports = exports;
